import sidebarStore from "@/src/store/sidebarStore";
import { rotateStorageSessionId } from "@/src/util/storage-session";
import { clear as clearIndexedDb } from "idb-keyval";

/** User preferences that survive account switch / logout. */
const PRESERVED_LOCAL_STORAGE_KEYS = new Set([
  "app-theme-storage",
  "app-storage",
  "header-config-storage",
]);

const clearLocalStorageExceptPreferences = () => {
  if (typeof window === "undefined") {
    return;
  }
  for (let i = localStorage.length - 1; i >= 0; i -= 1) {
    const key = localStorage.key(i);
    if (key && !PRESERVED_LOCAL_STORAGE_KEYS.has(key)) {
      localStorage.removeItem(key);
    }
  }
};

export async function resetClientSessionState(): Promise<void> {
  if (typeof window === "undefined") {
    return;
  }

  sessionStorage.clear();
  rotateStorageSessionId();
  clearLocalStorageExceptPreferences();

  try {
    await clearIndexedDb();
  } catch (err) {
    console.warn("[resetClientSessionState] failed to clear IndexedDB", err);
  }

  sidebarStore.setState({ badges: [] });
}

export async function revokeAuthTokens(): Promise<void> {
  if (typeof window === "undefined") {
    return;
  }
  try {
    await fetch("/api/auth/tokens", {
      method: "DELETE",
      credentials: "include",
    });
  } catch (err) {
    console.warn("[revokeAuthTokens] failed to clear auth cookies", err);
  }
}
